import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer';
import Newsletter from '../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import ContactForm from '../components/ContactForm';

export default function Contact() {

    return (
        <>
            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Contact Grand Indigo</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Contact Us</li>
                    </ul>
                </div>
            </section>

            <section className="contact-section">
                <div className="container">
                    <div className="row g-5">

                        {/* ── Contact Form Column ── */}
                        <div className="col-lg-7">
                            <ContactForm className="contact-form-wrapper" />
                        </div>

                        {/* ── Contact Details Column ── */}
                        <div className="col-lg-5">
                            <div className="contact-details-wrapper">
                                <h3 className="contact-details-title">Contact Information</h3>
                                <p className="contact-details-description">
                                    Reach out to us through any of these channels.
                                </p>

                                <div className="contact-details-list">
                                    <div className="contact-detail-item">
                                        <div className="contact-detail-icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                            </svg>
                                        </div>
                                        <div className="contact-detail-content">
                                            <h4 className="contact-detail-label">Phone</h4>
                                            <a href="tel:(213) 582-4757" className="contact-detail-value">(213) 582-4757</a>
                                        </div>
                                    </div>

                                    <div className="contact-detail-item">
                                        <div className="contact-detail-icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                                <polyline points="22,6 12,13 2,6" />
                                            </svg>
                                        </div>
                                        <div className="contact-detail-content">
                                            <h4 className="contact-detail-label">Email</h4>
                                            <a href="mailto:info@grandindigoembroidery.com" className="contact-detail-value">info@grandindigoembroidery.com</a>
                                        </div>
                                    </div>

                                    <div className="contact-detail-item">
                                        <div className="contact-detail-icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                                                <circle cx="12" cy="10" r="3" />
                                            </svg>
                                        </div>
                                        <div className="contact-detail-content">
                                            <h4 className="contact-detail-label">Location</h4>
                                            <p className="contact-detail-value">
                                                445 S Figueroa St #3187, Los Angeles, CA 90071, United States
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="contact-social-section">
                                    <h4 className="contact-social-title">Follow Us</h4>
                                    <div className="contact-social-links">
                                        <a href="https://www.facebook.com/profile.php?id=61586062061689&sk=directory_links" target="_blank" rel="noopener noreferrer" className="contact-social-link" aria-label="Facebook">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                                            </svg>
                                        </a>
                                        <a href="https://www.instagram.com/grand_indigo_embroidery?igsh=MW5zYWFyajZmb2x3ag==" target="_blank" rel="noopener noreferrer" className="contact-social-link" aria-label="Instagram">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                                                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                                                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                                            </svg>
                                        </a>
                                        <a href="https://www.linkedin.com/in/grand-indigo-embroidery-digitizing-69779b371/" target="_blank" rel="noopener noreferrer" className="contact-social-link" aria-label="LinkedIn">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" />
                                                <circle cx="4" cy="4" r="2" />
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <Newsletter />
            <Footer />
        </>
    );
}